import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

import md5 from 'crypto-js/md5';

configure({ enforceActions: 'always' });

class ConventionStore extends LocalModel {
    constructor() {
        super('convention', {
            namePlural: 'conventions',
            namePluralReal: 'conventions',
            sort: '-startDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/conventions/',
                    params: {
                        limit: 15,
                        sort: '-startDate',
                    },
                },
                load: {
                    url: '/api/conventions/',
                    params: {},
                },
                save: {
                    url: '/api/conventions/',
                    params: {},
                },
                delete: {
                    url: '/api/conventions/',
                    params: {},
                },
            },
        });
    }

    @observable reloadTimer = null;

    @observable newConvention = {};

    @observable convention = {};

    @observable conventions = [];

    @observable participants = [];

    @observable tags = [];

    @observable jwtToken = null;

    @observable otp = '';

    @observable summary = {};

    @observable disciplineMapLoaded = 0;

    @observable disciplineMap = [
        // ['fin', 'grov', 'mil', 'rev', 'sp.rev', 'sp.pistol', 'mag1', 'mag2'],
        {
            key: 'fin',
            id: "8058ce1c-fd4c-41d1-ad35-72db3f9b6c2e",
            name: "Finfelt",
            disciplineCode: "5",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302516,
            niF_Id: 300316,
        },
        {
            key: 'grov',
            id: "13062da9-6280-41ab-9dd5-e7bf3aa00704",
            name: "Grovfelt",
            disciplineCode: "11",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302516,
            niF_Id: 300317,
            deleted: false,
        },
        {
            key: 'mil',
            id: "5e666bb9-e59c-4dbd-96e3-c3a825ed8f87",
            name: "Militærfelt",
            disciplineCode: "8",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302516,
            niF_Id: 300319,
            deleted: false,
        },
        {
            key: 'rev',
            id: "3a3cc313-9575-4863-b0f3-ca1c3c66336e",
            name: "Revolverfelt",
            disciplineCode: "9",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302516,
            niF_Id: 300318,
            deleted: false,
        },
        {
            key: 'sp.rev',
            id: "13ebbe4a-034e-40d2-8008-066c30883212",
            name: "Spesialrevolver",
            disciplineCode: "71",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302518,
            niF_Id: 300320,
            deleted: false,
        },
        {
            key: 'sp.pistol',
            id: "5328e2ab-a720-40b9-8d8d-9e594bed3e6a",
            name: "Spesialpistol",
            disciplineCode: "73",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302518,
            niF_Id: 302644,
            deleted: false,
        },
        {
            key: 'mag1',
            id: "09430a6b-872e-45e8-aabc-8a86fd0d51c8",
            name: "Magnumfelt 1",
            disciplineCode: "72",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302518,
            niF_Id: 302645,
        },
        {
            key: 'mag2',
            id: "532764a5-879c-4e61-bd3c-e235277b2c05",
            name: "Magnumfelt 2",
            disciplineCode: "74",
            branchId: "0beff7e2-94f7-4284-b76e-fc3e17b29e4f",
            niF_ParentId: 302518,
            niF_Id: 302646,
        },
    ];

    @observable classMapLoaded = 0;

    @observable classMap = [];

    @action
    setReloadTimer = (timer) => {
        if (this.reloadTimer) {
            clearTimeout(this.reloadTimer);
        }
        this.reloadTimer = timer;
    }

    @action
    deleteReloadTimer = () => {
        clearTimeout(this.reloadTimer);
    }

    async getJwt(convention) {
        const response = await util.fetchApi(`/api/conventions/jwt/${convention}`, { method: 'GET' }, {});
        switch (response.status) {
            case 200:
                this.updateKeyValue('jwtToken', response.data.jwtToken);
                this.updateKeyValue('otp', response.data.otp);
                return response;
            default:
                return 'Error';
        }
    }

    async checkOtp(convention, otp) {
        const response = await util.fetchApi(`/api/conventions/otp/${convention}/${otp}`, { method: 'GET' }, {});
        switch (response.status) {
            case 200:
                return response;
            default:
                return 'Error';
        }
    }

    async signUp(user, shootingClass) {
        const response = await util.fetchApi(`/api/conventions/signup/${this.convention.id}`, { method: 'PATCH' }, {
            id: this.convention.id,
            participants: {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                cellphone: user.cellphone,
                email: user.email,
                class: shootingClass,
                md5: md5(JSON.stringify(user)).toString(),
                signupDate: new Date(),
            },
        });
        switch (response.status) {
            case 202:
                return response;
            default:
                return 'Error';
        }
    }

    async signUpAsAdmin(user) {
        // console.log('signUp', user);
        await this.save({
            id: this.convention.id,
            participants: {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                cellphone: user.cellphone,
                email: user.email,
                md5: md5(JSON.stringify(user)).toString(),
            },
        });
    }

    async newRound(type) {
        if (!type) {
            return;
        }
        // const participants = [...this.convention.participants];
        const prevStageNumber = this.convention.stages.length;
        const prevStage = this.convention.stages[prevStageNumber - 1];
        const nextDate = new Date(prevStage?.date || this.convention.startDate || new Date());
        if (prevStage?.date) {
            nextDate.setMinutes(nextDate.getMinutes() + this.convention.stageInterval || 10);
        }

        const stageNumber = this.convention.stages.length + 1;

        const newStage = {
            type,
            stages: type === 'norgesfelt' ? 8 : null,
            name: `Lag ${stageNumber}`,
            date: nextDate,
            idx: stageNumber,
            stageSlots: this.convention.stageSlots,
            stageClosed: 1,
        };
        newStage.md5 = md5(JSON.stringify(this.convention.stages)).toString();

        const response = await this.save({
            id: this.convention.id,
            // [`participants${stageNumber}`]: participants,
            stages: newStage,
        });

        return response;
    }

    async newParticipant(user = {}, stageMd5 = null) {
        if (!user.id) {
            return;
        }

        let stageName = 'participants';
        let currentStage;
        if (stageMd5) {
            const stageIdx = this.convention.stages.findIndex((s) => s.md5 === stageMd5);
            if (stageIdx >= 0) {
                stageName = `participants${stageIdx + 1}`;
                currentStage = this.convention.stages[stageIdx];
            }
        }

        // console.log('this.convention.stages', this.convention.stages);
        // console.log('currentStage', currentStage);

        if (currentStage && currentStage.stageSlots > 0) {
            const totalParticipants = this.convention[stageName].length;
            if (totalParticipants >= currentStage.stageSlots) {
                alert('Max antall deltakere nådd');
                return;
            }
        }

        // Check if participant already exists
        const existingParticipant = this.convention[stageName].find((p) => p.id === user.id);
        if (existingParticipant) {
            alert('Deltakeren er allerede påmeldt');
            return;
        }

        const response = await this.save({
            id: this.convention.id,
            [stageName]: {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                cellphone: user.cellphone,
                email: user.email,
                md5: md5(JSON.stringify(user)).toString(),
                date: util.isoDate(),
                signupDate: new Date(),
            },
        });
        return response;
    }

    @action
    async loadDisciplineMap() {
        const now = new Date().getTime();
        if (now - this.disciplineMapLoaded < 1000 * 60 * 60 * 1) { // Reload every 1 hour
            return;
        }
        this.updateKeyValue('disciplineMapLoaded', now);

        const response = await util.fetchApi(`/api/integrations/rubic/disciplines`, { method: 'GET' }, {});
        switch (response.status) {
            case 200:
                console.log('rubicGetDisciplines', response);
            default:
                // console.log('rubicGetDisciplines', response);
        }
        if (response.data) {
            // Merge with existing disciplineMap
            const newMap = this.disciplineMap.map((d) => {
                const found = response.data.find((r) => r.id === d.id);
                if (found) {
                    return { ...d, ...found };
                }
                return d;
            });
            // Add new disciplines
            response.data.forEach((d) => {
                if (!newMap.find((existing) => existing.id === d.id)) {
                    newMap.push(d);
                }
            });
            this.updateKeyValue('disciplineMap', newMap);
        }
    }

    @action
    async loadClassMap() {
        const now = new Date().getTime();
        if (now - this.classMapLoaded < 1000 * 60 * 60 * 1) { // Reload every 1 hour
            return;
        }
        this.updateKeyValue('classMapLoaded', now);

        const response = await util.fetchApi(`/api/integrations/rubic/classes`, { method: 'GET' }, {});
        switch (response.status) {
            case 200:
                console.log('rubicGetClasses', response);
            default:
                // console.log('rubicGetClasses', response);
        }
        if (response.data) {
            this.updateKeyValue('classMap', response.data);
        }
    }

    getNsfFallbackClass() {
        const fallbackClass = this.classMap.find(c => c.id === '32c29bc5-d0be-4639-a70f-1b17e886e3cd');
        return fallbackClass;
    }
}

const store = new ConventionStore();
export default store;
